import { React, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Routes, Route } from "react-router-dom";
import BinLookerUpper from './forms/binlookerupper/BinLookerUpper';
import TopBar from './shared-components/TopBar';
import Footer from './shared-components/Footer'; 
import { BrowserRouter } from 'react-router-dom';
import { HashRouter } from 'react-router-dom';
import Header from './shared-components/Header';

const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  <div  >

    <Header />

    <main>
        <BrowserRouter basename="/forms" >
        {/* basename="/forms" */}
          <Routes>
            <Route
              path='/waste-and-recycling-collection-dates'
              element={<BinLookerUpper />}
            />
          </Routes>
        </BrowserRouter>
    </main>

    <Footer />
  </div>
); 